import React from "react"

const SkeletonLoader = () => {
  return (
    <div className="hidden xl:block w-[15%] xl:w-[25%] h-screen bg-white rounded-lg shadow-md p-6 space-y-4">
      {[...Array(15)].map((_, i) => (
        <div key={i} className="h-4 bg-gray-200 rounded animate-pulse" />
      ))}

      <div className="flex gap-4 pt-2">
        <div className="h-10 w-24 bg-gray-200 rounded animate-pulse" />
        <div className="h-10 w-24 bg-gray-200 rounded animate-pulse" />
      </div>
    </div>
  )
}

export default SkeletonLoader
